import { useState } from 'react';
import FlatDeals from '../FlatDeals';
import FlexDeals from '../FlexDeals';
import { InboxContainer } from './style';

type DealView = 'flat' | 'flex';

const Inbox = () => {
  const [activeView, setActiveView] = useState<DealView>('flat');

  const handleViewChange = (view: DealView) => {
    setActiveView(view);
  };

  return (
    <InboxContainer>
      <div className='view-content'>
        {activeView === 'flat' ? (
          <FlatDeals activeView={activeView} onViewChange={handleViewChange} />
        ) : (
          <FlexDeals activeView={activeView} onViewChange={handleViewChange} />
        )}
      </div>
    </InboxContainer>
  );
};

export default Inbox;
